module.exports = __webpack_public_path__ + "img/hn.3677841e.svg";